import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio, Select, MenuItem } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import { useEffect } from "react";
import { TIEJUN_LEVELS, TIEJUN_LEVEL_MAP } from "src/config/constants";


// console.log(levels, TIEJUN_LEVEL_MAP)

const RejectApplyDialog = ({ open, onClose, onConfirm }) => {
  const [form, setForm] = useState({
    reason: "",
  });


  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    onConfirm(form)
  }


  return (
    <FormDialog title="拒绝" open={open} onClose={onClose} onConfirm={handleConfirm}>
      
      <FormItem title="理由" required>
        <TextField fullWidth value={form.reason} size="small" onChange={e => handleIptChange('reason', e.target.value)} />
      </FormItem>

    </FormDialog>
  );
};

export default RejectApplyDialog;
